import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Are you a fund?',
  answer: 'No. We are a research lab that prototypes ideas.'
}, {
  question: 'Do you manage external capital?',
  answer: 'No. This is an educational, pre-professional lab.'
}, {
  question: "Can I join if I'm not a quant?",
  answer: "Yes. We want artists, philosophers, linguists, historians — if you're rigorous and curious."
}, {
  question: 'IP & publishing?',
  answer: 'Team-owned within the lab; case-by-case open-sourcing after a cooling period.'
}, {
  question: 'Time commitment?',
  answer: '~5–7 hrs/week during sprints; lighter between.'
}, {
  question: "What's the selection process?",
  answer: 'Short application → mini prompt → coffee chat. We look for builders and curious minds.'
}];
export function FAQ() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="w-full py-32 px-6 bg-navy-900" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-bold mb-16 text-center text-white" data-id="element-27">
          FAQ
        </motion.h2>
        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 * index
        }} className="bg-navy-800 border-2 border-navy-700 rounded-lg overflow-hidden hover:border-steel transition-all duration-300" data-id="element-29">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-navy-700 transition-colors" data-id="element-30">
                <span className="text-lg font-semibold text-white" data-id="element-31">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-steel transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-32" />
              </button>
              <AnimatePresence data-id="element-33">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-34">
                    <div className="px-6 pb-5 text-slate" data-id="element-35">{faq.answer}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}